import { BFF_BASE_URL } from "@src/app/utils/bff";
import { useState } from "react";
import { useLocation } from "react-router";

export type NewsletterVariant =
  | "default"
  | "regional"
  | "culture"
  | "card"
  | "cultureCard"
  | "regionalCard";

type NewsLetterCode = 1 | 2;

type NewsletterPostRequestBody = {
  email: string;
  newsletterCode: NewsLetterCode;
  utmSource: string;
  path: string;
};

type NewsletterPostResponse = {
  code: number;
  response: {
    msg?: string;
    errorMsg?: string;
  };
};

export function useNewsletterSignUp(variant: NewsletterVariant = "default") {
  const [value, setValue] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();

  const checkEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidEmailPattern = /^\.|\.{2,}|@\.|\..*@$|^[^@]+@\.$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email");
      return false;
    }
    if (invalidEmailPattern.test(email)) {
      setError("Please enter a valid email");
      return false;
    }
    if (email.split("@")[0].endsWith(".")) {
      setError("Please enter a valid email");
      return false;
    }
    return true;
  };

  const onSubmit = async (email: string) => {
    // Reset states
    setSuccess("");
    setError("");

    if (checkEmail(email)) {
      const isThinkCulture = variant === "cultureCard" || variant === "culture";
      const utmSourceString: string =
        new URLSearchParams(location.search).get("utm_source") || "";
      const newsletterCode: NewsLetterCode = isThinkCulture ? 2 : 1;
      const newsletterPostRequestBody: NewsletterPostRequestBody = {
        email,
        newsletterCode,
        utmSource: utmSourceString,
        path: location.pathname,
      };

      try {
        const res = await fetch(`${BFF_BASE_URL}/client/midas/newsletter`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newsletterPostRequestBody),
        });
        const data = (await res.json()) as NewsletterPostResponse;
        if (data.response.errorMsg) {
          setSuccess("");
          setError(data.response.errorMsg);
          return;
        }
        if (data.response.msg) {
          setError("");
          setSuccess(data.response.msg);
          return;
        }
      } catch (e: unknown) {
        setError("Newsletter sign up failed");
        return;
      }
    } else {
      setError("Please enter a valid email");
      return;
    }
  };

  return {
    value,
    setValue,
    success,
    setSuccess,
    error,
    setError,
    onSubmit,
  };
}
